import ApiResponseV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponseV2";
import GenericCrudServiceV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudServiceV2";
import HttpClientV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2";
import WorkLogMonthly from "../models/WorkLogMonthly";
import environment from "../environment.json";

class WorkLogMonthlyService extends GenericCrudServiceV2<WorkLogMonthly> {
  path: string;

  constructor(path: string) {
    super(path);
    this.path = path;
  }

  async lockReport(project: String, date: Date, isLocked: Boolean): Promise<ApiResponseV2<WorkLogMonthly>> {
    const url: string = `${environment.baseURL}${this.basePath}/lock-report`;
    return await HttpClientV2.post(url, { projectExternalId: project, firstDayOfMonth: date, locked: isLocked });
  }

  async getByDateAndProject(project: String, year: number, month: number): Promise<ApiResponseV2<WorkLogMonthly>> {
    const url: string = `${environment.baseURL}${this.basePath}/get-by-date-and-project?year=${year}&month=${month}&projectExternalId=${project}`;
    return await HttpClientV2.get(url);
  }
}

export default new WorkLogMonthlyService("/ensolvers-ops/work-log-monthly");
